import { render, staticRenderFns } from "./ClientRoles.vue?vue&type=template&id=00c8e9f6"
import script from "./ClientRoles.vue?vue&type=script&lang=js"
export * from "./ClientRoles.vue?vue&type=script&lang=js"
import style0 from "./ClientRoles.vue?vue&type=style&index=0&id=00c8e9f6&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports